var parent = require('../../es/instance/some');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/some.js
// module id = 1118
// module chunks = 0